import { render, staticRenderFns } from "./TestSetting.vue?vue&type=template&id=c8bbf0d2&scoped=true&"
import script from "./TestSetting.vue?vue&type=script&lang=js&"
export * from "./TestSetting.vue?vue&type=script&lang=js&"
import style0 from "./TestSetting.vue?vue&type=style&index=0&id=c8bbf0d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bbf0d2",
  null
  
)

export default component.exports